export default __webpack_public_path__ + "static/media/Odin-Logo-white.bd9f40a6.svg";